(function () {
    'use strict';

    function decimalSearchField() {
        return {
            restrict: 'E',
            scope: {
                attribute: '=',
                changeEvent: '&'
            },
            templateUrl: 'common/directives/templates/decimalSearchField.html',
            link: function (scope, element, attrs) {
                scope.hasChangeEvent = attrs.changeEvent;
            }
        };
    }

    decimalSearchField.$inject = [];

    angular.module('ecap.common').directive('decimalSearchField', decimalSearchField);
})();